import React from "react";

const OnboardingStepsProgress = ({ progress }) => {
  return (
    <div className={`mx-36`}>
      <div className="w-full h-3 rounded-md bg-gray-100 relative">
        <div
          className={`rounded-md`}
          style={{
            width: `${progress}%`,
            background: "#7f56d9",
            height: "100%",
          }}
        />

        {/* steps */}
        <div className="absolute -left-5 -top-3 flex items-center justify-center rounded-full h-10 w-10 bg-gray-100">
          <div className="h-3 w-3 rounded-full bg-purple3" />
        </div>

        {/* steps */}
        <div className="absolute left-[48%] -top-3 flex items-center justify-center rounded-full h-10 w-10 bg-gray-100">
          <div className="h-3 w-3 rounded-full bg-purple3" />
        </div>

        {/* steps */}
        <div className="absolute -right-5 -top-3 flex items-center justify-center rounded-full h-10 w-10 bg-gray-100">
          <div className="h-3 w-3 rounded-full bg-purple3" />
        </div>
      </div>
    </div>
  );
};

export default OnboardingStepsProgress;
